import { render, staticRenderFns } from "./PlanPageTrainings.vue?vue&type=template&id=f984a6ea&scoped=true&"
import script from "./PlanPageTrainings.vue?vue&type=script&lang=js&"
export * from "./PlanPageTrainings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f984a6ea",
  null
  
)

export default component.exports